/* unplugin-vue-components disabled */import { render } from "./menuTopbar.vue?vue&type=template&id=c5a39f5c"
import script from "./menuTopbar.vue?vue&type=script&lang=js"
export * from "./menuTopbar.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\sama_vue_ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__